import { Grid, FormControlLabel, Typography, Checkbox, FormControl } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';

const MultiselectQuestion = (props) => {
    const { question, questionnaireIndex, questionIndex, editMode, name = null } = props;
    const { formState, setValue } = useFormContext();
    const { errors } = formState;
    const [selected, setSelected] = useState(
        question?.Options?.map((option) => {
            return { id: option?.Value, value: question?.Default !== null && question?.Default.includes(option?.Value) };
        })
    );

    useEffect(() => {
        if (name) {
            setValue(
                `${name}[${questionnaireIndex}].answers[${questionIndex}].answer`,
                question?.Default ? question?.Default.map((answer) => answer) : []
            );
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        } else {
            setValue(
                `questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`,
                question?.Default ? question?.Default.map((answer) => answer) : []
            );
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        }
    }, [questionIndex, questionnaireIndex]);

    const handleCheckbox = (event, value) => {
        setSelected((prev) => {
            return prev.map((item) => {
                if (item.id === value) {
                    return { ...item, value: event.target.checked };
                }
                return item;
            });
        });
    };

    useEffect(() => {
        if (name) {
            setValue(
                `${name}[${questionnaireIndex}].answers[${questionIndex}].answer`,
                selected?.filter((item) => item.value).map((item) => item.id)
            );
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        } else {
            setValue(
                `questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`,
                selected?.filter((item) => item.value).map((item) => item.id)
            );
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        }
    }, [selected]);

    return (
        <Grid item container xs={12}>
            <Grid item xs={12}>
                <Typography gutterBottom variant="h4">
                    {question?.Title}
                </Typography>
            </Grid>
            {question?.Options && (
                <Grid item xs={12}>
                    <FormControl
                        sx={{
                            borderColor: 'red'
                        }}
                        error={
                            name
                                ? !!errors[`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`]
                                : !!errors[`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`]
                        }
                        required={question?.rules?.required}
                        size="small"
                        fullWidth
                        disabled={!editMode}
                    >
                        {question?.Options.sort((a, b) => a?.Position - b?.Position).map((option) => {
                            return (
                                <FormControlLabel
                                    key={option?.Value}
                                    value={option?.Value}
                                    control={
                                        <Checkbox
                                            defaultChecked={question?.Default?.includes(option?.Value)}
                                            onChange={(e) => handleCheckbox(e, option?.Value)}
                                        />
                                    }
                                    label={option?.Label}
                                />
                            );
                        })}
                    </FormControl>
                </Grid>
            )}
        </Grid>
    );
};

export default MultiselectQuestion;
